import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { fadeInUp400ms } from '../../../../@vex/animations/fade-in-up.animation';
import icMail from '@iconify/icons-ic/twotone-mail';
import { itemService } from '../../../helpers/services/main.service'
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'vex-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  animations: [fadeInUp400ms]
})
export class ForgotPasswordComponent implements OnInit {

  form = this.fb.group({
    email: [null, Validators.required],
    role: ['null', Validators.required]
  });

  icMail = icMail;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private itemService: itemService,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit() {
  }

  send() {
    if (this.form.value.email) {
      this.itemService.forgotPassw(this.form.value).subscribe((data: any) => {
        if (data.status) {
          this.snackbar.open('Email was sent.', 'OK', {
            duration: 5000
          });
          this.router.navigate(['/login']);
        } else {
          this.snackbar.open(`Username or email wasn't found.`, 'OK', {
            duration: 5000
          });
        }
      })
    }
  }
}
